module.exports = __webpack_public_path__ + "img/IMG-20180802-WA0007.e40d6e86.jpg";